import { HEADING_WEIGHT7 } from 'HubStyleTokens/misc';
import { HEADING7 } from 'HubStyleTokens/sizes';
import styled from 'styled-components';

import { FONT_FAMILIES, setFontSize } from '../../utils/Styles';
import Heading, { HeadingProps } from '../Heading';

export type H7Props = Omit<HeadingProps, 'tagName'>;

const H7 = styled(Heading).attrs({
  tagName: 'h2',
})`
  ${FONT_FAMILIES[HEADING_WEIGHT7]};
  ${setFontSize(HEADING7)};
`;

H7.displayName = 'H7';

export default H7;
